module.exports = __webpack_public_path__ + "static/yuan_ti_pit_master-dcd99bd57ec166c60c94ca9347d4272a.jpeg";